<template>
  <div>
    <div class="public_top animate__animated animate__fadeInLeft" v-if="configInfo">
      <div class="flex align-center justify-between public_top_tips">
        <div>{{ configInfo.company_name }}</div>
        <div class="flex align-center">
          <el-dropdown class="changeLaunage">
            <span class="el-dropdown-link">
              <div class="flex align-center">
                <el-image class="change" :src="require('@/assets/images/changeLaunage.png')" fit="fill"></el-image>
                <div v-if="$store.state.language == 'zh'">{{ $t('public.zh') }}</div>
                <div v-if="$store.state.language == 'ru'">{{ $t('public.ru') }}</div>
                <div v-if="$store.state.language == 'kk'">{{ $t('public.kk') }}</div>
              </div>
            </span>
            <el-dropdown-menu slot="dropdown" class="launage">
              <el-dropdown-item>
                <div class="fontStyle" @click="changeLaunage('zh')">
                  {{ $t('public.zh') }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="fontStyle" @click="changeLaunage('ru')">
                  {{ $t('public.ru') }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="fontStyle" @click="changeLaunage('kk')">
                  {{ $t('public.kk') }}
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="userInfo && userInfo.user_id">
            <span class="el-dropdown-link">
              <div class="public_top_righttwo flex mouseGestures animate__animated animate__fadeInRight">
                <img class="personal" :src="require('@/assets/images/personal.png')" alt="" />
                <span>{{ userInfo.nickname || '' }}</span>
              </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="fontStyle" @click="goMine">
                  {{ $t('public.personal') }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="fontStyle" @click="logout">
                  {{ $t('login.logout') }}
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>


          <div class="login public_top_right mouseGestures animate__animated animate__fadeInRight" @click="openLogin" v-else>
            <span> {{ $t('login.noLogin') }}</span>
            <span class="text-red"> {{ $t('login.goLogin') }}</span>
          </div>
        </div>
      </div>

      <div class="flex align-center justify-between public_top_cont">
        <el-image class="logo" :src="configInfo.logo" fit="fill"></el-image>
        <div class="flex align-center animate__animated animate__fadeInLeft tabsWrap">
          <div class="flex align-center tabs mouseGestures">
            <div class="tabItem" :class="{ 'tabActive': $store.state.navTopindex == index }" v-for="(item, index) in navArray" :key="index" @click="goNav(item, index)">
              <span class="nav">{{ item.name }}</span>
              <div class="line" v-if="index == $store.state.navTopindex"></div>
            </div>
          </div>

          <el-dropdown>
            <span class="el-dropdown-link">
              <el-image class="more" :src="require('@/assets/images/more.png')" fit="fill"></el-image>
            </span>
            <el-dropdown-menu slot="dropdown" class="launage">
              <el-dropdown-item v-for="(item, index) in navArray" :key="index">
                <div @click="goNav(item, index)">
                  <span style="padding-right: 10px;" class="fontStyle">{{ item.name }}</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- 登录弹框 -->
    <loginVue />
    <!-- 退出登录 -->
    <logout />
  </div>
</template>
<script>
import { mapState } from "vuex";
import loginVue from "@/components/loginMoudel/login.vue"; //登录
import logout from "@/components/loginMoudel/logout.vue"; //退出登录
export default {
  components: { loginVue, logout },
  data() {
    return {
      configInfo: null,
      navArray: [
        {
          name: this.$t('public.sy'),
          path: "/",
        },
        {
          name: this.$t('public.cybj'),
          path: "/layout",
        },
        {
          name: this.$t('public.xw'),
          path: "/news",
        },
        {
          name: this.$t('public.zs'),
          path: "/solicit",
        },
        {
          name: this.$t('public.cp'),
          path: "/product",
        },
        {
          name: this.$t('public.zb'),
          path: "zb",
        },
        {
          name: this.$t('public.lxwm'),
          path: "/contact",
        },
      ],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.getConfigData()
  },
  watch: {
    '$i18n.locale': function (newVal) {
      console.log(newVal)
      location.reload();
    }
  },
  methods: {
    //路由跳转
    goNav(item, index) {
      if (item.path == "zb") {
        window.open(this.configInfo.live_url, "_blank");
      } else {
        this.$store.commit('upDatetopindex', index)
        this.$router.push(item.path);
      }
    },
    // 获取配置数据
    getConfigData() {
      this.$api({
        url: "/api/index/get_config",
        method: "post",
        data: {
        }
      }).then((res) => {
        this.configInfo = res.data
      })
    },
    // 切换语言
    changeLaunage(language) {
      this.$i18n.locale = language
      this.$store.commit('changeLaunage', language)
    },
    openLogin() {
      // 打开登录弹框
      this.$store.commit("updataLogin", true);
    },
    goMine() {
      // 跳转个人资料
      this.$router.push("/personalCenter");
    },
    // 退出登录
    logout() {
      // 打开退出登录弹框
      this.$store.commit("updataLogout", true);
    },
    // 校验登录
    checkAuth() {
      if (!this.userInfo || !this.userInfo.user_id) {
        this.$store.commit("updataLogin", true);
        return
      }
    }
  },
};
</script>
<style lang="less" scoped>
.public_top {
  height: 120px;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif !important;

  .public_top_tips {
    height: 40px;
    padding: 0 200px;
    font-size: 14px;
    color: #333;
    background: #F5F7F8;

    .changeLaunage {
      margin-right: 50px;

      .change {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }

      .launage {
        font-size: 16px;
      }
    }

    .personal {
      width: 16px;
      height: 18px;
      margin-right: 5px;
    }

    .login {
      font-size: 14px;

      .text-red {
        color: #E70012;
      }
    }
  }

  .public_top_cont {
    width: 100%;
    height: 80px;
    padding: 0 200px;
    background-color: white;
    box-sizing: border-box;

    .logo {
      width: 76px;
      height: 54px;
    }

    .tabsWrap {
      max-width: calc(100% - 100px);

      .tabs {
        width: calc(100% - 24px);
        font-size: 20px;
        color: #333333;
        overflow: hidden;
        overflow-x: scroll;
        box-sizing: border-box;

        .tabItem {
          width: auto;
          height: 66px;
          line-height: 66px;
          text-align: center;
          white-space: nowrap;
          padding: 0 40px;
          box-sizing: border-box;

          .nav {
            display: flex;
            justify-content: space-around;
            align-items: center;
            letter-spacing: -0.3px;
          }
        }

        .tabActive {
          font-weight: bold;
          color: #E70012;
          position: relative;

          .line {
            width: 34px;
            height: 4px;
            background: #E70012;
            position: absolute;
            bottom: 0;
            transform: translate(-50%);
            left: 50%;
          }
        }

        .tabItem:hover {
          color: #E70012;
        }
      }

      .more {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
